import axios from 'axios'
import cookies from 'vue-cookies'

export default {
  namespaced: true,
  state: {
    freeDocumentsGroupsGrid: [],
    freeDocumentsGroupsShow: {},
    pageData: null,
  },
  mutations: {
    setFreeDocumentsGroupsGrid(state, payload) {
      state.freeDocumentsGroupsGrid = payload
    },
    setFreeDocumentsGroupsShow(state, payload) {
      state.freeDocumentsGroupsShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
  },
  getters: {
    freeDocumentsGroupsGrid: (state) => state.freeDocumentsGroupsGrid,
    freeDocumentsGroupsShow: (state) => state.freeDocumentsGroupsShow,
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onFreeDocumentsGroupsGrid({ commit, rootState }, { type, limit, page, sort, search }) {
      commit('setLoadingAnimation', true, { root: true })
      let url =
        rootState.apiDomain +
        `/api/${type}/work/free-document/${type === 'admin' ? 'group/grid' : 'groups'}`
      if (page) {
        url = url + '?limit=' + Number(limit) + '&page=' + page
      }
      if (type === 'admin') {
        if (sort) {
          url = url + '&order[]=' + sort.param + ':' + sort.value
        } else {
          url = url + '&order[]=name:asc'
        }
      }
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setFreeDocumentsGroupsGrid', resp.data.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onFreeDocumentsGroupsShow({ commit, rootState }, { type, id }) {
      commit('setLoadingAnimation', true, { root: true })

      let url = rootState.apiDomain + `/api/${type}/work/free-document/`
      if (type === 'admin') {
        url = url + 'group/' + id
      } else {
        url = url + 'groups?filter[]=id:' + id
      }
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit(
              'setFreeDocumentsGroupsShow',
              type === 'admin' ? resp.data.data : resp.data.data.find((i) => i.id === Number(id)),
            )
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onFreeDocumentsGroupsCreate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/free-document/group',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onFreeDocumentsGroupsUpdate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/free-document/group',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onFreeDocumentsGroupsDelete({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/free-document/group/' + id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
